import type { StrapiCollectionResponse, StrapiEntityResponse, StrapiRequestParams } from '~/types/strapi';
import { stringify } from 'neoqs';

export default defineNuxtPlugin({
  name: 'kygunco:strapi',
  dependsOn: [],
  parallel: true,
  setup: () => {
    const config = useRuntimeConfig();

    const fetch = $fetch.create({
      baseURL: `${config.public.strapi.url ?? 'https://content.kygunco.com'}/api`,
    });

    const stringifyParams = (params?: unknown) => stringify(params, { encodeValuesOnly: true });

    const find = async <T>(collection: string, params?: StrapiRequestParams<T>) =>
      fetch<StrapiCollectionResponse<T>>(`/${collection}?${stringifyParams(params)}`);

    const first = async <T>(
      collection: string,
      params: StrapiRequestParams<T>,
      fail?: boolean) => {
      const response = await find<T>(collection, { ...params, pagination: { start: 0, limit: 1 } });

      if (!response.data.length && fail) {
        throw createError({ status: 404, statusMessage: 'Not Found' });
      }

      return response.data[0];
    };

    const get = async <T>(
      collection: string,
      id: number | string,
      params?: StrapiRequestParams<T>) =>
      fetch<StrapiEntityResponse<T>>(`${collection}/${id}?${stringifyParams(params)}`);

    const single = async <T>(collection: string, params?: StrapiRequestParams<T>) =>
      fetch<StrapiEntityResponse<T>>(`${collection}?${stringifyParams(params)}`);

    return {
      provide: {
        strapi: {
          fetch,
          find,
          first,
          get,
          single,
        },
      },
    };
  },
});
